import { type Feature, FeatureType } from '@/app/components/search/components/Card/utils/facilitiesTypes.ts';
import {
  getActiveFacilities,
  getIcon,
  getText,
} from '@/app/components/search/components/Card/utils/facilitiesUtils.ts';
import type { TranslationFunction } from '@/app/components/translations/Translation.tsx';
import { FACILITIES } from '@/app/components/search/utils/FacilitiesType.ts';
import type { ProductAccommodationFacilities } from '@/domainLogic/types/typesProduct.ts';

// const blacklisted = ['disableGuest'];

export const getFacilities = ({
  facilities,
  max,
  t,
  hasChildren,
  showIcons,
}: {
  facilities: ProductAccommodationFacilities;
  imageBasePath: string;
  max: number;
  t: TranslationFunction;
  hasChildren: boolean;
  showIcons: boolean;
}): Feature[] => {
  const allowedFacilities = [
    FACILITIES.SEAFRONT,
    FACILITIES.SPA,
    FACILITIES.SWIMMING_POOL,
    FACILITIES.PARKING,
    FACILITIES.FREE_WIFI,
    ...(hasChildren ? [FACILITIES.CHILDREN] : [FACILITIES.ADULTS_ONLY]),
    FACILITIES.ENTERTAINMENT,
    FACILITIES.PETS_ALLOWED,
    FACILITIES.KITCHEN,
  ];

  const features = getActiveFacilities(facilities, allowedFacilities);
  const limitedFeatures = features.slice(0, max);

  return limitedFeatures.map((facility: FACILITIES, index: number) => {
    const isLast = index === limitedFeatures.length - 1;

    return {
      icon: showIcons
        ? getIcon(facility)
        : ({ category: 'UI Essentials', name: 'icon-bullet', color: 'iconPrimary' } as const),
      text: getText(facility, t) as string,
      iconRight:
        showIcons && !isLast
          ? ({ category: 'UI Essentials', name: 'icon-bullet', color: 'iconDisabled' } as const)
          : undefined,
      className: 'facilities',
      featureType: FeatureType.normal,
    };
  });
};
